import React, { Component } from 'react';
import { APP_CONST } from '../../constants';
import { GeckoCard, GeckoAlert, GeckoFields, ProfileList, Spinner, GeckoBtn } from '../../components';
import { $state } from '../../router';
import { Auth, TokenManager, ClientManager } from '../../services';
import SessionTable from './components/SessionTable';
import Composer from './components/Composer';
import { GeckoModalService, GeckoModal } from '@geckolabs/gecko-react-ui';

// Styles
import './styles.css';

export class ActiveSessions extends Component {
    state = {
        sessions: [],
        composer: false,
        profiles: [],
        apps: {},
        accounts: {},
        loadingProfiles: false,
    }

    constructor(props) {
        super(props);

        this.getSessions = this.getSessions.bind(this);
        this.deleteToken = this.deleteToken.bind(this);
        this.didCreateToken = this.didCreateToken.bind(this);
    }
   
    /* ====================

        Lifcycle

    ==================== */

    componentDidMount() {
        this.getSessions();
    }

    /* ====================

        Global Methods

    ==================== */

    /**
     * Fetch list of all active sessions i.e JWT tokens
     */
    getSessions() {
        return Auth.sessions().then((data) => {
            this.setState({
                sessions: data,
            })
        })
        .catch((err) => {
            this.setState({ alert: err.Error });
        })
    }

    deleteToken(setId) {
        Auth.deleteApiToken(setId)
        .then(() => {
            const sessions = this.state.sessions;

            const updatedSessions = sessions.filter((session) => session.SetId !== setId);

            this.setState({
                sessions: updatedSessions,
            })
        });
    }

    /**
     * Open Modal with token Composer
     */
    openComposer() {
        const onCreate = this.didCreateToken;
        return new GeckoModalService().open(()=> {
            return (
                <GeckoModal name="Create New API Token" btns={[]}>
                    <Composer onCreate={onCreate} />
                </GeckoModal>
            );
        });
    }

    didCreateToken() {
        this.getSessions();
        new GeckoModalService().close();
    }

    /* ====================

        Renders

    ==================== */

    renderAlert(message = null) {
        if (message) {
            return (
                <GeckoAlert className="z-depth-3 stickyAlert" type={APP_CONST.ALERT_TYPE_SUCCESS}>
                    {message}
                </GeckoAlert>
            )
        }

        return null;
    }

    renderSessions(sessions) {
        if (sessions.length === 0) {
            return (
                <GeckoCard padded={true}>
                    <div className="">
                        No active sessions
                    </div>
                </GeckoCard>
            )
        }

        return (
            <GeckoCard padded={true}>
                <SessionTable data={this.state.sessions} revoke={this.deleteToken} />
            </GeckoCard>
        )
    }

    render() {
        return (
            <div>
                {this.renderSessions(this.state.sessions)}
                <GeckoBtn 
                    handler={this.openComposer.bind(this)} 
                    name="Create New API token" 
                    icon= "plus"
                    type={APP_CONST.BTN_TYPE_PRIMARY}
                />
            </div>
        );
    }
}

export default ActiveSessions;
